import  { useState } from 'react';
import BottomPageSelector from './BottomPageSelector';

export const usePagination = (defaultSortField) => {
  const [sorting, setSorting] = useState({
    columnId: defaultSortField,
    order: 1,
  });
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');
  const [pagination, setPagination] = useState({ itemsPerPage: 10, page: 0 });
  return {
    sorting,
    setSorting,
    filter,
    setFilter,
    search,
    setSearch,
    pagination,
    setPagination,
  };
};

function BottomPageSelectorWithPagination({
  setPagination,
  pagination,
  length,
}) {
  if (!length) return null;
  return (
    <BottomPageSelector
      changePage={(value) =>
        setPagination({
          ...pagination,
          page:
            pagination.page + value >= 0 &&
            pagination.page + value <=
              Math.ceil(length / pagination.itemsPerPage) - 1
              ? pagination.page + value
              : pagination.page,
        })
      }
      changePageLength={(value) =>
        setPagination({
          page: 0,
          itemsPerPage: value,
        })
      }
      itemMinIndex={pagination.page * pagination.itemsPerPage + 1}
      itemMaxIndex={(pagination.page + 1) * pagination.itemsPerPage}
      totalItems={length || 0}
      resultsPerPage={pagination.itemsPerPage}
    />
  );
}

export default BottomPageSelectorWithPagination;
